













































































































































































































































import {
    Vue, Component, Prop, Watch,
} from 'vue-property-decorator'
// import MP4Box from 'mp4box';
import HoverMask from '@/components/HoverMask.vue'
import common from '@/common'
import api from '@/api'
import reg from '@/util/reg'
import util from '@/util'

@Component({
    name: 'UploadFile',
    components: {
        HoverMask,
    },
})
export default class UploadFile extends Vue {
    reg: any = reg

    $refs!: {
        uploadInput: any,
        dropdownRef: any
    }

    @Prop({default: ''}) value!: any                    // v-model绑定的值

    @Prop({default: false}) isAllowFile!: boolean      // 是否允许文件

    @Prop({default: false}) isMultiple!: boolean        // 是否多选

    @Prop({default: 2048}) size!: number                  // 文件大小

    @Prop({default: false}) multi!: boolean         // 是否为多张图片

    @Prop({default: 1}) limit!: number              // 默认只能上传一张图片

    @Prop({default: false}) isSingleArray!: boolean   // multi为false时，绑定的v-model是否是单数组结构 [{name: '', url: ''}]、[{url: ''}]、['']

    @Prop({default: ''}) nameKey!: string       // 需要文件名时的name字段

    @Prop({default: ''}) urlKey!: string         // 需要文件名时的url字段

    @Prop({default: false}) disabled!: boolean   // 是否禁用

    @Prop({default: false}) compress!: boolean  // 是否压缩

    @Prop({default: ''}) accept!: string      // 支持的文件类型

    @Prop({default: true}) isShowTip!: boolean // 是否展示tip

    @Prop({default: false}) isUpdate!: boolean // 是否刷新页面

    @Prop({default: false}) isDrag!: boolean

    @Prop({default: true}) canUpload!: boolean

    @Prop({default: true}) isDownload!: boolean // 图片是否可下载

    @Prop({default: false}) wdShow!: boolean // width展示item

    @Prop({default: false}) imgListView!: boolean // 图片是否显示为列表

    @Prop({default: true}) isShowUpload!: boolean // 仅查看不显示upload按钮

    @Prop({default: false}) hidePreview!: boolean // 是否隐藏文件预览

    @Prop({default: true}) canDownload!: boolean

    @Prop({default: false}) isDragCheck!: any // 多选检验密码

    @Prop({default: false}) supportPaste!: any // 显示粘贴输入框

    @Prop({default: false}) loading!: any     // 是否上传中

    // @Prop({default: false}) checkMov!: any

    pictures: Array<object> = []

    files: Array<object> = []

    imgDialog: boolean = false

    showImgUrl: string = ''

    isLoading: boolean = false      // 是否上传中

    uploadList: any = []

    // invalidMovList: any = []

    // invalidMovDlgVisible: boolean = false

    invalidAcceptVisible: boolean = false

    // get iosCameraStepList() {
    //     return [
    //         this.configCommon.ossPrefix + 'web-static/assets/ios_camera_step1.png',
    //         this.configCommon.ossPrefix + 'web-static/assets/ios_camera_step2.png',
    //         this.configCommon.ossPrefix + 'web-static/assets/ios_camera_step3.png',
    //     ]
    // }

    get chooseFileStepList() {
        return [
            this.configCommon.ossPrefix + 'web-static/assets/custom_choose_file.png',
        ]
    }

    get fileType() {
        return this.isAllowFile ? this.accept : 'image/jpeg,image/png'
    }

    get fileList() {
        return [...this.pictures, ...this.files]
    }

    get acceptList() {
        return this.accept ? this.accept.split(',').map(item => item.trim().toLowerCase()) : []
    }

    get filterAcceptList() { // 从 image/jpeg,image/png 取出image
        return this.acceptList.filter(item => item.endsWith('/*')).map(item => item.substring(0, item.lastIndexOf('/')))
    }

    @Watch('isLoading')
    handleLoadingChange(val) {
        this.$emit('update:loading', val)
    }
    /**
     * 用于更新处理v-model绑定的值
     * 支持处理的数据结构
     *          单个文件上传
     *                  {name: '', url: ''}
     *                  {url: ''}
     *                  ''
     *                  [{name: '', url: ''}]
     *                  [{url: ''}]
     *                  ['']
     *           多个文件上传
     *                  ['']
     *                  [{name: '', url: ''}]
     *                  [{url: ''}]
     */
    @Watch('value', {immediate: true, deep: true})
    updateValue() {
        if (!this.value || this.value.length === 0) {
            this.pictures.splice(0)
            this.files.splice(0)
            return
        }
        let list:any[] = []
        if (this.multi) {
            if (this.urlKey) {
                if (this.nameKey) {
                    list = this.value.map((item: any) => ({
                        name: item[this.nameKey],
                        url: common.getCompleteUrl(item[this.urlKey]),
                    }))
                } else {
                    list = this.value.map((item: any) => ({
                        url: common.getCompleteUrl(item[this.urlKey]),
                    }))
                }
            } else {
                list = this.value.map((item: any) => ({url: common.getCompleteUrl(item)}))
            }
        } else if (this.value) {
            if (this.urlKey) {
                if (this.nameKey) {
                    if (this.isSingleArray) {
                        list = [{
                            name: this.value.length ? this.value[0][this.nameKey] : '',
                            url: this.value.length ? common.getCompleteUrl(this.value[0][this.urlKey]) : '',
                        }]
                    } else {
                        // 针对单文件{name: '', url: ''}，删除为空后，不渲染
                        if (this.value[this.urlKey] === '') {
                            list = []
                        } else {
                            list = [{
                                name: this.value[this.nameKey],
                                url: common.getCompleteUrl(this.value[this.urlKey]),
                            }]
                        }
                    }
                } else if (this.isSingleArray) {
                        list = [{
                            url: this.value.length ? common.getCompleteUrl(this.value[0][this.urlKey]) : null,
                        }]
                    } else {
                        // 针对单文件{url: ''}，删除为空后，不渲染
                        if (this.value[this.urlKey] === '') {
                            list = []
                        } else {
                            list = [{
                                url: common.getCompleteUrl(this.value[this.urlKey]),
                            }]
                        }
                    }
            } else {
                list = [{
                    url: this.isSingleArray ? (this.value.length ? common.getCompleteUrl(this.value[0]) : null) : common.getCompleteUrl(this.value),
                }]
            }
        }

        // list = list.filter(item => item.name)

        // 区分文件和图片展示
        if (this.isAllowFile) {
            let pictures: any = []
            let files: any = []
            list.forEach(item => {
                if (reg.reImg.test(item.url) || ((!this.hidePreview && !this.imgListView) && reg.reVideo.test(item.url))) {
                    pictures.push(item)
                } else {
                    files.push(item)
                }

            })
            this.pictures = pictures
            this.files = files
        } else {
            this.pictures.splice(0, this.pictures.length, ...list)
        }
    }

    isImg(url) {
        return reg.reImg.test(url)
    }

    handleClick() {
        if (!this.isLoading && !this.disabled) {
            this.$refs.uploadInput.dispatchEvent(new MouseEvent('click'))
        }
    }

    uploadFile(file, fileName) {
        // console.log('uploadFile 1111')
        // let formData = new FormData()
        // formData.append('file', file)
        // formData.append('fileName', fileName)
        // return api.upload_file(formData)

        return api.upload_oss_file({ fileName }).then(({ data }) => {
            // console.log('uploadFile 2222')
            const formData = new FormData();
            formData.append('name', fileName);
            formData.append('policy', data.policy);
            formData.append('OSSAccessKeyId', data.ossAccessKeyId);
            formData.append('success_action_status', '200');
            formData.append('signature', data.signature);
            formData.append('key', data.dir + '/' + data.uploadFileName);
            formData.append('file', file);
            return fetch(data.host, { method: 'POST', body: formData}).then(res => {
                if (res.status === 200) {
                    // console.log('uploadFile 3333')
                    return {
                        data: data.dir + '/' + data.uploadFileName
                    }
                } else {
                    // console.log('uploadFile 555')
                    throw('')
                }
            })
        })
    }

    async changeUpload(fileList?) {
        // 如果支持多选图片时,FileList会有多个
        let FileList
        if (fileList.length) {
            FileList = fileList
        } else [
            FileList = [...this.$refs.uploadInput.files]
        ]
        this.$emit('startUpload')
        this.isLoading = true
        let promiseList: any = []
        if (FileList.length > 0) {
            if (!this.validteFileAccept(FileList)) {
                this.invalidAcceptVisible = true
                this.isLoading = false
                this.$emit('uploadFailed')
                return
            }

            // if (this.checkMov) {
            //     this.invalidMovList = []
            //     for (let i = 0; i < FileList.length; i++) {
            //         let item = FileList[i]
            //         if (item.type === 'video/quicktime') {
            //             if (await this.isHEICMOV(item)) {
            //                 this.invalidMovList.push(item)
            //             }
            //         }
            //     }
            //     if (this.invalidMovList.length) {
            //         this.invalidMovDlgVisible = true
            //         this.isLoading = false
            //         this.$emit('uploadFailed')
            //         return
            //     }
            // }

            for (let i = 0; i < FileList.length; i++) {
                let item = FileList[i]
                // 判断上传文件大小
                const isOversized = item.size / 1048576 > this.size
                const filename = item.name.toLowerCase()
                const isHeic = filename.endsWith('.heic') || filename.endsWith('.heif') // 不支持上传苹果专用格式。 各平台兼容太差，不好支持，直接禁止，免去沟通成本
                if (!isOversized && !isHeic) {
                    let file = item
                    // 上传是否需要压缩处理
                    if (this.compress && item.type.includes('image/')) {
                        file = await util.compressImg(item, 0.5)
                    }
                    promiseList[i] = this.uploadFile(file, item.name)
                } else {
                    this.isLoading = false
                    this.$emit('uploadFailed')
                    return this.$message.error(isOversized ? 'File is oversized.' : 'The file format you\'ve selected is not supported. ')
                }
            }
            // 在所有的上传接口结束后，统一处理数据
            Promise.all(promiseList).then((res: any) => {
                // console.log('uploadFile 444: ', res)
                let list: any = []
                res.map((item: any, index: number) => {
                    let data = item.data ? item.data : ''
                    let obj: any = ''
                    if (this.urlKey) {
                        obj = {}
                        if (this.nameKey) {
                            obj[this.urlKey] = data
                            obj[this.nameKey] = FileList[index].name
                        } else {
                            obj[this.urlKey] = data
                        }
                    } else {
                        obj = data
                    }
                    list.push(obj)
                })
                if (this.multi) {
                    this.value.push(...list)
                    this.$emit('add', list)
                } else {
                    this.$emit('input', this.isSingleArray ? list : list[0])
                    this.$emit('add', this.isSingleArray ? list : list[0])
                }
                if (this.isUpdate) {
                    this.$emit('updateSuccess')
                }
            }, (err) => {
                this.$emit('uploadFailed', err)
                // this.$message.error(reject.message)
            }).finally(() => {
                this.isLoading = false
            })

            // 处理上传相同文件的问题
            this.$refs.uploadInput.value = ''

            this.uploadList = []
        }
    }

    validteFileAccept(fileList) { // 校验文件所选文件是否符合accpt
        if (!this.acceptList.length || this.acceptList.includes('*')) return true
        return fileList.every(file => {
            let type = file.type.toLowerCase()
            if (this.acceptList.includes(type)) {
                return true
            } else {
                return this.filterAcceptList.some(item => type.startsWith(item))
            }
        })
    }

    // async isHEICMOV(file) {
    //     const codec: any = await this.getVideoCodec(file)
    //     return codec.startsWith('hvc1')
    // }


    // async getVideoCodec(file) {
    //     const buffer = await file.arrayBuffer()
    //     const mp4box = new MP4Box.createFile()

    //     return new Promise((resolve) => {
    //         mp4box.onReady = (info) => {
    //             const videoTrack = info.tracks.find(track => track.type === 'video')
    //             resolve(videoTrack.codec)
    //         }
    //         buffer.fileStart = 0
    //         mp4box.appendBuffer(buffer)
    //     });
    // }


    handleDelete(file: any, list: any, e?: any) {
        this.$confirm('Are you sure you want to delete ' + (file.name || '') + '?', 'Prompt', {
            confirmButtonText: this.$t1('delete'),
            cancelButtonText: this.$t1('cancel'),
            type: 'warning',
        }).then(() => {
            let sequence = -1
            sequence = list.findIndex((item: any) => item === file)
            let deletedFile
            if (sequence !== -1) {
                deletedFile = list.splice(sequence, 1)
                this.$emit('delete', deletedFile[0])
            }
            if (this.multi) {
                let index = this.value.findIndex(item => file.url.includes(this.urlKey ? item[this.urlKey] : item))
                this.value.splice(index, 1)
            } else {
                let lists:any = []
                // 针对[{url: '', name: ''}]、[{url: ''}]、['']
                // 传出的结构为[]
                if (this.isSingleArray) {
                    lists = []
                } else {
                    // 针对单文件为{name: '', url: ''}、{url: ''}、''这种结构处理
                    // 保证传进的结构与传出的结构一致
                    if (this.urlKey) {
                        if (this.nameKey) {
                            lists = {
                                [this.nameKey]: '',
                                [this.urlKey]: '',
                            }
                        } else {
                            lists = {
                                [this.urlKey]: '',
                            }
                        }
                    } else {
                        lists = ''
                    }
                }
                this.$emit('input', lists)
            }
            if (sequence !== -1) {
                this.$emit('deleteSuccess', deletedFile[0])
            }
            if (this.isUpdate) {
                this.$emit('updateRemove')
            }
        })
    }

    handleShow(picture: any) {
        this.imgDialog = true
        this.showImgUrl = ''
        this.showImgUrl = picture.url
    }

    handleDownload(file: any) {
        common.downloadOssFile(common.getRelativeUrl(file.url), file.name)
    }

    openPdfUrl(url) {
        common.openOssUrl(url)
    }

    beforeUplaod(file) {

    }

    httpRequest(arg) {
        this.$refs.dropdownRef.hide()

        const file = arg.file
        this.changeUpload([file])
    }

    async handlePaste(e) {
        const items = e.clipboardData?.items || []
        const fileList: any[] = []
        for (let i = 0; i < items.length; i++) {
            const item = items[i]
            let result

            // 1) 如果是文件（常见截图/图片）
            if (item.kind === 'file') {
                const file = item.getAsFile()
                if (file && file.type) {
                    result = file
                }
            } else if (item.kind === 'string') { // 2) 如果是字符串（可能是 base64）
                if (['text/html', 'text/plain'].includes(item.type)) {
                    await new Promise(resolve => {
                        item.getAsString(txt => {
                            result = this.getFileFromStr(txt)
                            resolve(txt)
                        })
                    })
                }
            }
            
            const clipboard: any = navigator.clipboard
            if (!result && clipboard && clipboard.read) {
                try {
                    const clipboardItems = await clipboard.read()
                    debugger
                    for (const citem of clipboardItems) {
                        for (const type of citem.types) {
                            if (type.startsWith('image/')) {
                                // debugger
                                result = util.blobToFile(await citem.getType(type), Date.now() + '.png')
                                break
                            }
                            // 也可以尝试 text/html/text/plain via getType
                            if (['text/html', 'text/plain'].includes(type) && citem.getType) {
                                try {
                                    // debugger
                                    const blob = await citem.getType(type)
                                    // blob for text types — convert to text
                                    if (blob && blob.size) {
                                        const txt = await blob.text()
                                        // debugger
                                        result = this.getFileFromStr(txt)
                                    }
                                } catch (err) { /* ignore */ }
                            }
                        }
                    }
                } catch (err) {
                    console.warn('navigator.clipboard.read() failed or blocked:', err)
                }
            }
            // console.log('result: ', result)
            if (result) {
                fileList.push(result)
            }
        }
        if (fileList.length) {
            this.changeUpload(fileList)
            e.preventDefault() // 阻止原始图片数据粘到 textarea 里
        }
    }

    getFileFromStr(text) {
        const match = text.match(/src=["'](data:image\/[^"']+)["']/)
        if (match && match[1]) {
            return util.base64ToFile(match[1], Date.now() + '.png')
        }
    }
}
